import { ReactComponent as InfoIcon } from "@/assets/icons/info.svg";

interface IHelpButtonProps {
  onClick: () => void;
  label: string;
}

export const HelpButton = ({ onClick, label }: IHelpButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className="flex items-center gap-2 border border-purple10 !bg-white text-purple10 whitespace-nowrap text-sm sm:text-[16px] h-[44px] sm:h-[58px] rounded-full px-4 font-bold"
  >
    <InfoIcon className="shrink-0" />
    {label}
  </button>
);
